var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-4 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-8 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("filter-manager", {
        ref: "filterRef",
        staticClass: "mb-4",
        attrs: { filters: _vm.filtersConfig },
        on: {
          academicYear: _vm.onAcademicYearChange,
          search: function($event) {
            return _vm.onSearchHandler(1)
          }
        },
        model: {
          value: _vm.filterModel,
          callback: function($$v) {
            _vm.filterModel = $$v
          },
          expression: "filterModel"
        }
      }),
      _c("custom-separator", {
        staticClass: "my-4",
        attrs: { text: "Resultados" }
      }),
      _vm.results.length == 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No cuenta con información disponible." }
          })
        : _vm._e(),
      _vm._l(_vm.results, function(row) {
        return _c("result-row", {
          key: row.id,
          attrs: { id: row.id, data: row }
        })
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }